<script lang="ts">
    import type {AxiosInstance} from 'axios';
    import {fade} from 'svelte/transition';

    import {modal, dyData} from 'general/store';
    import {STATE, ANIMATION_DURATION, TEMPLATE} from 'general/constants';

    import FlipWrapper from 'general/components/flip/wrapper/FlipWrapper.svelte';
    import Backdrop from 'general/components/backdrop/Backdrop.svelte';
    import Position from 'desktop/components/position/Position.svelte';
    import CloseButton from 'general/components/closeButton/CloseButton.svelte';
    import MainSide from './state/Main.svelte';
    import ThankYouSide from './state/ThankYou.svelte';
    import Theme from 'general/theme/Theme.svelte';
    import ProductImage from './helpers/ProductImage/ProductImage.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;

    const OPTIONS = {
        [STATE.MAIN]: {component: MainSide, props: {instance}},
        [STATE.TYP]: {component: ThankYouSide, props: {}},
        [STATE.ALREADY_SUBSCRIBED]: {component: ThankYouSide, props: {}},
    } as const;
</script>

<div transition:fade|global={{duration: ANIMATION_DURATION.MODAL}}>
    <Position>
        <FlipWrapper template={TEMPLATE.SQUARE_PRODUCT}>
            <Theme template={TEMPLATE.SQUARE_PRODUCT} color={$dyData.side.main.backgroundColor}>
                <div class={s.wrapper}>
                    <svelte:component
                        this={OPTIONS[$modal.state].component}
                        {...OPTIONS[$modal.state].props}
                    />
                    <CloseButton
                        handleClick={modal.close}
                        theme={TEMPLATE.SQUARE_PRODUCT}
                        crossColor={'#393939'}
                    />
                    <ProductImage {instance} />
                </div>
            </Theme>
        </FlipWrapper>
    </Position>
    <Backdrop />
</div>
